/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useLoading } from '../../../../../presentation/contexts/loading'
import { useMe } from '../../../../../presentation/contexts/me'
import { usePage } from '../../../../../presentation/contexts/page'
import { excerpt } from '../../../../../presentation/helpers/helper-string'
import ITable from '../../../../../presentation/interfaces/table'
import UserList from '../../../../../presentation/pages/dashboard/configurations/user/list'
import { theme } from '../../../../../presentation/styles/theme'
import { makeUsers } from '../../../../usecases/users/load-users'

const initialData: ITable = {
  headerItems: [
    { label: 'ID', size: 0.5, component: 'Text' },
    { label: 'Nome', size: 3, component: 'Text' },
    { label: 'Tipo de Acesso', size: 3, component: 'Text' },
    { label: 'Ativo', size: 1, component: 'Switch' },
    {
      label: 'Ações',
      size: 1,
      component: 'Actions',
      type: 'action',
    },
  ],
  items: [],
  actions: [
    { icon: 'edit', text: 'Editar', color: '#0172CB' },
  ],
  hasCheckbox: true,
  stylesOptions: {
    headerTitle: {
      color: theme.colors.blue,
      fontWeight: theme.font.medium,
      fontFamily: theme.font.inter,
      fontSize: theme.font.sizes.medium,
    },
  },
}

const MakeUserList = () => {
  const history = useHistory()
  const { me } = useMe()
  const { setHeader } = usePage()
  const { onSetLoading } = useLoading()
  const [data, setData] = useState<ITable>(initialData)
  const [filteredData, setFilteredData] = useState<ITable>(initialData)
  const [listUpdated, setListUpdated] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [canEnableAddUserBtn, setCanEnableAddUserBtn] = useState(true)

  const toggleSwitchField = async (user: any, field: string, isCustomer = false) => {
    if (isCustomer) return
    const currentValue = user[field]
    const itemToSubmit = { isActive: !currentValue }

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeUsers(stablishmentId).patch(user.id, itemToSubmit)
      setListUpdated((state) => !state)
    } catch (error) {
      // console.log(error)
    }
  }

  const goToEditor = (currentData: any = null) => {
    if (currentData) {
      history.push({
        pathname: '/dashboard/users/editor',
        state: { item: currentData.item },
      })
    } else {
      history.push({
        pathname: '/dashboard/users/editor',
        state: { item: null },
      })
    }
  }

  const formatProfileToTable = (profiles: any) => (
    profiles.map((profile: any) => profile.name).join(' / ')
  )

  const formatDataToTable = (response: any) => {
    const usersFormatted: any = []

    response.users.forEach((user: any) => {
      const isCustomer = !!(user.customer)
      usersFormatted.push({
        item: user,
        datas: [
          {
            value: user.id,
            parent: 'ID',
          },
          {
            value: user.fullname,
            parent: 'Nome',
          },
          {
            value: excerpt(formatProfileToTable(user.profiles), 100),
            parent: 'Tipo de Acesso',
          },
          {
            value: user.isActive,
            parent: 'Ativo',
            canShow: !isCustomer,
            handler: () => toggleSwitchField(user, 'isActive', isCustomer),
          },
        ],
      })
    })

    const newData = { ...initialData }
    newData.items = usersFormatted
    newData.actions = [
      {
        icon: 'edit',
        handler: goToEditor,
        text: 'Editar',
        color: '#0172CB',
        hoverColor: '#C8E7FF',
      },
    ]

    return newData
  }

  const handleSearchUser = async (value: string) => {
    setSearchTerm(String(value))
    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeUsers(stablishmentId).load({ term: value })
      const filteredProfile = { ...formatDataToTable(response) }
      setFilteredData(filteredProfile)
    } catch (error) {
      // console.log(error)
    }
  }

  // Get data from api and format to list
  useEffect(() => {
    (
      async () => {
        setHeader({
          title: 'Usuários',
          goTo: null,
        })
        onSetLoading(true)
        if (!me) return
        const stablishmentId = me.stablishments[0].id
        const response = await makeUsers(stablishmentId).load()
        const newData = { ...formatDataToTable(response) }
        setData(newData)
        const canShowBtn = newData.items.length < me.stablishments[0].waiterAmount
        setCanEnableAddUserBtn(canShowBtn)
        if (!filteredData) {
          setFilteredData(newData)
        }
        if (listUpdated) {
          setListUpdated((state) => !state)
        }
        onSetLoading(false)
      }
    )()
  }, [me, listUpdated])

  useEffect(() => {
    (
      async () => {
        setFilteredData(data)
      }
    )()
  }, [data])

  return (
    <UserList
      searchTerm={searchTerm}
      setSearchTerm={handleSearchUser}
      tableData={filteredData}
      goToEditor={goToEditor}
      canEnableAddUserBtn={canEnableAddUserBtn}
    />
  )
}

export default MakeUserList
